module.exports = "<sx-template-listado \r\n  [titulo]=\"'PAYMENT_GATEWAYS' | i18next\"\r\n  [link]=\"link\"\r\n  [listado]=\"payments\"> \r\n</sx-template-listado>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/paymentGateways/list.payment.gateways.component.html
// module id = ../../../../../src/app/private/paymentGateways/list.payment.gateways.component.html
// module chunks = main